import { render } from "./MobileTabModal.vue?vue&type=template&id=23ceb3ea&scoped=true"
import script from "./MobileTabModal.vue?vue&type=script&lang=js"
export * from "./MobileTabModal.vue?vue&type=script&lang=js"

import "./MobileTabModal.vue?vue&type=style&index=0&id=23ceb3ea&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23ceb3ea"]])

export default __exports__